import { render, staticRenderFns } from "./ChartCard.vue?vue&type=template&id=33a2b10c&scoped=true"
import script from "./ChartCard.vue?vue&type=script&lang=js"
export * from "./ChartCard.vue?vue&type=script&lang=js"
import style0 from "./ChartCard.vue?vue&type=style&index=0&id=33a2b10c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a2b10c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33a2b10c')) {
      api.createRecord('33a2b10c', component.options)
    } else {
      api.reload('33a2b10c', component.options)
    }
    module.hot.accept("./ChartCard.vue?vue&type=template&id=33a2b10c&scoped=true", function () {
      api.rerender('33a2b10c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/dashboard/analysis/ChartCard.vue"
export default component.exports